export const reduceToUID = (str) => {
    return str.split(' ').join('_').toLowerCase();
};
export const populateObjectUID = (obj, alt = 'name') => ({
    ...obj,
    uid: obj?.uid ?? reduceToUID(Array.isArray(obj[alt]) ? obj[alt].join('_') : obj[alt]),
});
export const populateArrayUID = (alt, data) => {
    return data.map(el => populateObjectUID(el, alt));
};
export const populatePrice = (obj, price) => ({
    ...obj,
    price: Number.isFinite(price) ? price : price?.[obj?.group] ? price?.[obj?.group] : 0,
});
export function formatPrice(num = 0) {
    return (Number(num) || 0).toLocaleString('de-DE');
}
export function formatDateTime(date = new Date()) {
    const pad = (n) => String(n).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    let hours = date.getHours();
    const minutes = pad(date.getMinutes());
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours === 0 ? 12 : hours; // 12-hour clock
    return `DATE: ${year}-${month}-${day} TIME ${pad(hours)}:${minutes} ${ampm}`;
}
